// t120 (6-oct-2026) · EL ESPACIO DE LA CLÍNICA, LLENO.
//
// Al 100 % del espacio de la clínica en Biango, el servidor contesta 413 con `codigo: 'ESPACIO_LLENO'` a cualquier subida
// nueva del equipo (backend/services/espacioLleno: documentos, fotos, radiografías, adjuntos, la Nube…), y services/api.js
// lanza el evento `biango:espacio-lleno` con lo que dijo. Aquí se explica en una ventana: qué ha pasado (no se ha borrado
// nada; lo firmado, las facturas y lo que llega de fuera se siguen guardando) y qué hacer: ampliar con un pack (quien
// puede contratarlo, que el servidor dice en `puede_ampliar`) o liberar espacio. No se repite en cada intento: se cierra
// y vuelve a salir la siguiente vez que se intente subir algo pasados unos minutos.
import { useEffect, useState } from 'react'
import { irALosPacks } from '../utils/nubePacks'
import { t, tx } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

const REPETIR_MS = 5 * 60 * 1000

const gigas = (bytes) => {
  const g = (Number(bytes) || 0) / 1024 ** 3
  return (g >= 100 ? String(Math.round(g)) : (Math.round(g * 10) / 10).toFixed(1).replace(/\.0$/, '').replace('.', ',')) + ' GB'
}

export default function AvisoEspacioLleno() {
  const [aviso, setAviso] = useState(null)
  const [cerradoAt, setCerradoAt] = useState(0)

  useEffect(() => {
    const h = (e) => {
      const d = (e && e.detail) || {}
      if (Date.now() - cerradoAt < REPETIR_MS) return
      setAviso(d)
    }
    window.addEventListener('biango:espacio-lleno', h)
    return () => window.removeEventListener('biango:espacio-lleno', h)
  }, [cerradoAt])

  if (!aviso) return null
  const cerrar = () => { setAviso(null); setCerradoAt(Date.now()) }
  const usado = aviso.espacio && Number(aviso.espacio.usado_bytes)
  const total = aviso.espacio && Number(aviso.espacio.total_bytes)
  const pct = total > 0 ? Math.min(100, Math.round((usado * 100) / total)) : 100
  // t464 · en un paso: a los packs con la ventana de firmar el pack recomendado ya abierta.
  const ampliar = () => { cerrar(); irALosPacks(undefined, { ampliar: true }) }

  return (
    <div className="modal-safe" role="alertdialog" aria-labelledby="espacio-lleno-titulo" data-aviso="espacio-lleno"
      style={{ position: 'fixed', inset: 0, zIndex: 1600, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', boxShadow: '0 20px 50px rgba(0,0,0,0.18)', width: '100%', maxWidth: '520px', padding: '22px' }}>
        <div id="espacio-lleno-titulo" style={{ fontSize: '18px', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '8px' }}>
          {t('components.AvisoEspacioLleno.el_espacio_de_la_clinica', 'El espacio de la clínica está lleno')}
        </div>
        {total > 0 && (
          <div style={{ marginBottom: '12px' }}>
            <div style={{ height: '8px', borderRadius: '6px', background: 'var(--border)', overflow: 'hidden' }}>
              <div style={{ width: pct + '%', height: '100%', background: 'var(--danger)' }} />
            </div>
            <div style={{ fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '4px' }}>{tx('components.AvisoEspacioLleno.de', '{{gigas}} de {{gigas2}}', { gigas: gigas(usado), gigas2: gigas(total) })}</div>
          </div>
        )}
        <div style={{ fontSize: '14px', lineHeight: 1.55, color: 'var(--text-secondary)' }}>
          {aviso.error || t('components.AvisoEspacioLleno.no_se_pueden_subir_archivos', 'No se pueden subir archivos nuevos hasta que se amplíe el espacio o se libere.')}
        </div>
        <ul style={{ fontSize: '13px', lineHeight: 1.5, color: 'var(--text-secondary)', margin: '12px 0 0', paddingLeft: '18px' }}>
          <li><b>{t('components.AvisoEspacioLleno.ampliar', 'Ampliar:')}</b>{t('components.AvisoEspacioLleno.con_un_pack_de_espacio', ' con un pack de espacio, en Tu cuenta de Biango (lo contrata la administración o la gerencia de la clínica). Vale desde el momento en que se firma y se cobra en la próxima factura de Biango, por los días que quedan de este mes.')}</li>
          <li><b>{t('components.AvisoEspacioLleno.liberar', 'Liberar:')}</b>{t('components.AvisoEspacioLleno.en_la_nube_borra_lo', ' en la Nube, borra lo que ya no necesites y vacía su papelera: deja de contar al momento. Lo que se borra en otros sitios pasa a la papelera de Biango y sigue contando hasta que sale de ella, a los 90 días.')}</li>
        </ul>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '18px' }}>
          {aviso.puede_ampliar && <button type="button" className="btn btn-primary" onClick={ampliar}>{t('components.AvisoEspacioLleno.ampliar_el_espacio', 'Ampliar el espacio')}</button>}
          <button type="button" className={aviso.puede_ampliar ? 'btn btn-secondary' : 'btn btn-primary'} onClick={cerrar}>{t('components.AvisoEspacioLleno.entendido', 'Entendido')}</button>
        </div>
      </div>
    </div>
  )
}
